// Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../state/ftp/actions';
import { clearForm, downloadFile } from '../state/documents/actions';
import { withRouter } from "react-router";

// Components
import Main from '../components/FTP/Main';

function mapStateToProps(state) {
	return {
	};
}

function mapDispatchToProps(dispatch) {
	return { 
		actions: bindActionCreators(actions, dispatch),
		downloadFile: bindActionCreators(downloadFile, dispatch),
		clearForm: bindActionCreators(clearForm, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Main));


// WEBPACK FOOTER //
// ./src/containers/FTPContainer.js